import React from "react";
import SearchableSelect from "../../../components/common/searchable-select";

const OTHER_BRANCH_VALUE = "other";

const TransactionSection = ({
  fProps,
  showErr,
  formIsDisabled,
  transactionProviders = [],
  loadingTransactionProviders = false,
  transactionBranches = [],
  loadingTransactionBranches = false,
  onProviderChange,
  onBranchChange,
}) => {
  const providerField = fProps("id_provider");
  const branchField = fProps("id_provider_branch");
  const isOtherBranch = branchField.value === OTHER_BRANCH_VALUE;

  const providerOptions = transactionProviders.map((p) => ({ value: String(p.id), label: p.name_th }));
  const branchOptions = [
    ...transactionBranches.map((b) => ({ value: String(b.id), label: b.name_th })),
    { value: OTHER_BRANCH_VALUE, label: "อื่นๆ" },
  ];

  return (
    <>
      <hr className="divider" />
      <div className="sub-section-label">สถานที่ชำระบริการ (Location Contact)</div>

      <div className="form-row">
        {/* dropdown 1: provider */}
        <div className="form-group">
          <label className="form-label">
            สถานที่ชำระบริการ <span className="req">*</span>
          </label>
          <SearchableSelect
            id="transaction_id_provider"
            name={providerField.name}
            value={providerField.value}
            onChange={onProviderChange}
            onBlur={providerField.onBlur}
            disabled={formIsDisabled || loadingTransactionProviders}
            isInvalid={providerField.className.includes("is-invalid")}
            options={providerOptions}
            placeholder={loadingTransactionProviders ? "กำลังโหลด..." : "เลือกสถานที่"}
          />
          {showErr("id_provider")}
        </div>

        {/* dropdown 2: branch */}
        <div className="form-group">
          <label className="form-label">
            สาขา Branch <span className="req">*</span>
          </label>
          <SearchableSelect
            id="transaction_id_provider_branch"
            name={branchField.name}
            value={branchField.value}
            onChange={onBranchChange || branchField.onChange}
            onBlur={branchField.onBlur}
            disabled={formIsDisabled || loadingTransactionBranches}
            isInvalid={branchField.className.includes("is-invalid")}
            options={branchOptions}
            placeholder={loadingTransactionBranches ? "กำลังโหลด..." : "เลือกสาขา"}
          />
          {showErr("id_provider_branch")}
        </div>
      </div>

      {/* input กรอกเองเมื่อเลือก อื่นๆ */}
      {isOtherBranch && (
        <div className="form-group mb">
          <label className="form-label">
            อื่นๆ <span className="req">*</span>
          </label>
          <input
            {...fProps("other_branch_name")}
            placeholder="อื่นๆ"
            autoComplete="off"
          />
        </div>
      )}

      {/* ── FIX: โชว์ field Google Map เสมอ ไม่ซ่อนแล้ว ── */}
      {/* ── เลือกสาขาจริง (ไม่ใช่ "อื่นๆ") → receiver_map ถูก auto-fill จากสาขา (onBranchChange ใน UserRequestDetail.jsx) และล็อคไว้ (read-only) ห้ามแก้เอง ── */}
      {/* ── เลือก "อื่นๆ" → ไม่มีสาขาให้ auto-fill ต้องปลดล็อคให้กรอกเอง ── */}
      <div className="form-group mb">
        <label className="form-label">Google Map</label>
        <input
          {...fProps("receiver_map")}
          disabled={formIsDisabled || !isOtherBranch}
          placeholder="Input"
          autoComplete="off"
        />
        {showErr("receiver_map")}
      </div>

      <div className="form-group mb">
        <label className="form-label" htmlFor="note">หมายเหตุ (Remark)</label>
        <textarea {...fProps("note")} placeholder="Type your message here" rows={3} />
      </div>
    </>
  );
};

export default TransactionSection;